import useNswagClient from '../../../hooks/api/useNswagClient';
import { Item } from '../../../app/services/api/generated';
import { useState, useCallback, useRef, useEffect } from 'react';
import debounce from 'lodash/debounce';
import axios, { CancelTokenSource } from 'axios';

const useItemSearch = () => {
  const { getItems } = useNswagClient();
  const [items, setItems] = useState<Item[]>([]);
  const [isSearching, setIsSearching] = useState(false);
  const cancelTokenSourceRef = useRef<CancelTokenSource | null>(null);

  const debouncedSearch = useCallback(
    debounce((search: string, storeNumber: string) => {
      if (cancelTokenSourceRef.current) {
        cancelTokenSourceRef.current.cancel('Cancelled due to new search.');
      }

      if (!search.trim()) {
        setItems([]);
        setIsSearching(false);
        return;
      }

      cancelTokenSourceRef.current = axios.CancelToken.source();
      const token = cancelTokenSourceRef.current.token;
      setIsSearching(true);

      getItems(search, storeNumber, undefined, undefined, undefined, true, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, token)
        .then((res) => {
          setItems(res?.data?.items ?? []);
          setIsSearching(false);
        })
        .catch((error) => {
          if (!axios.isCancel(error)) {
            console.error(error);
            setIsSearching(false);
          }
        });
    }, 500),
    [],
  );

  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
      cancelTokenSourceRef.current?.cancel('Component unmounted.');
    };
  }, [debouncedSearch]);

  return { items, setItems, isSearching, debouncedSearch };
};

export default useItemSearch;
